import { checkFlagment, getParameter, setParameter, getPath } from './common'
import FlpLogin from "./flp_login";
import ConnectApp from "./ConnectApp";

// 画面共通
// - jleague-client-scriptフラグメント内のJSに対応する
window.getParameter = getParameter
window.setParameter = setParameter

// Redirecting...の画面 (thymeleaf/refresh-to-reference-source.html)
window.getPath = getPath

// FLP ログイン
window.FlpLogin = FlpLogin
window.checkFlagment = checkFlagment

// ＪリーグIDをお忘れの方 (thymeleaf/login.html)
// - メールアドレス入力チェックでバリデーション依存に対応する
import { requiredRule, emailRule, loginAndPasswordChangejleagueIdRule } from './validation/rules'
window.requiredRule = requiredRule
window.emailRule = emailRule
window.loginAndPasswordChangejleagueIdRule = loginAndPasswordChangejleagueIdRule // メールアドレスでご登録された方はこちら(thymeleaf/login.html)のJリーグIDでバリデーション対応

// 他サイトアカウント連携 (thymeleaf/connect.html)
window.ConnectApp = ConnectApp

import Vue from 'vue';
import ChangeEmail from './vue/ChangeEmail'
import ChangeUserinfo from './vue/ChangeUserinfo'
import EmailConfirmationForSignup from "./vue/EmailConfirmationForSignup"
import Home from './vue/Home';
import Password from './vue/Password'
import Recovery from './vue/Recovery'
import RecoveryRequest from './vue/RecoveryRequest'
import Resign from './vue/Resign'
import Signup from "./vue/Signup"
import SignupForFlp from "./vue/SignupForFlp"
import FavoritePlayer from "./vue/FavoritePlayer.vue"

// Vue.js を使っている画面一覧
// Vue CLI などで作成したアプリではないので、画面毎に固有のIDをつけて衝突しないようにする
const VUE_APP_PAGES = [
    // メールアドレス変更 (thymeleaf/change-email.html)
    {
        id: 'jleague-change-email-app',
        component: ChangeEmail
    },
    // 会員情報変更, お気に入りクラブ, メール設定, 登録済みワンタッチパスID, ワンタッチパスID情報登録 (thymeleaf/change-userinfo.html)
    {
        id: 'jleague-change-userinfo-app',
        component: ChangeUserinfo
    },
    // ＪリーグID新規登録(メールアドレス入力) (thymeleaf/email-confirmation-for-signup.html)
    {
        id: 'jleague-email-confirmation-for-signup-app',
        component: EmailConfirmationForSignup
    },
    // ＪリーグIDメインメニュー (thymeleaf/home.html)
    {
        id: 'jleague-home-app',
        component: Home
    },
    // パスワード変更 (thymeleaf/password.html)
    {
        id: 'jleague-password-app',
        component: Password
    },
    // パスワードをお忘れの方 (thymeleaf/recovery.html)
    {
        id: 'jleague-recovery-app',
        component: Recovery
    },
    // パスワードをお忘れの方 (thymeleaf/recovery-request.html)
    {
        id: 'jleague-recovery-request-app',
        component: RecoveryRequest
    },
    // ＪリーグIDを退会する (thymeleaf/resign.html)
    {
        id: 'jleague-resign-app',
        component: Resign
    },
    // ＪリーグID新規登録 (thymeleaf/signup.html)
    {
        id: 'jleague-signup-app',
        component: Signup
    },
    // ＪリーグID新規登録 (public/flp/signup.html)
    {
        id: 'jleague-signup-for-flp-app',
        component: SignupForFlp
    },
    {
        id: 'jleague-favorite-player',
        component: FavoritePlayer
    },
]
Object.freeze(VUE_APP_PAGES)

document.addEventListener('DOMContentLoaded', () => {
    VUE_APP_PAGES.forEach((page) => {
        if (document.getElementById(page.id)) {
            new Vue(page.component).$mount(`#${page.id}`)
        }
    })
})
